import React from "react";
import ReactPaginate from "react-paginate";
import Pagination from "rc-pagination";
import { Images } from "../../../../../Assets/0a-exporter";
import JobOpeningCard from "../../../../Common/JobOpeningCard/JobOpeningCard";
import ApplyForJob from "../../../../Portals/ApplyForJob/ApplyForJob";
import LoginPortal from "../../../../Portals/LoginPortal/LoginPortal";
import SignupPortal from "../../../../Portals/SignupPortal/SignupPortal";
import { MainContext } from "../../../DashboardContext/Context";
import "./job-listing-body.style.scss";
export default function JobListingBody({
  currentJobList,
  setFilterConfig,
  filterConfig,
  otherJobListInfo,
  setMobileFilter,
  loading,
  unSaveJob,
  saveJob,
}) {
  const [openLogin, setOpenLogin] = React.useState(false);
  const [openSignUp, setOpenSignUp] = React.useState(false);
  const [applyModalOpen, setApplyModalOpen] = React.useState({
    status: false,
    data: null,
  });
  const context = React.useContext(MainContext);
  const { userDetails, savedJobs } = context;
  const handleApply = (obj) => {
    if (!userDetails) {
      setOpenLogin(true);
    } else {
      setApplyModalOpen({ status: true, data: obj });
    }
  };
  const handleStar = (obj, num) => {
    if (!userDetails) {
      setOpenLogin(true);
      return;
    } else {
      obj.saved
        ? unSaveJob({ obj: obj, num: num })
        : saveJob({ obj: obj, num: num });
    }
  };
  const decideLastNumber = () => {
    if (parseInt(otherJobListInfo.total / 9) === filterConfig.start - 1) {
      return (filterConfig.start - 1) * 9 + currentJobList.length;
    } else {
      return filterConfig.start * 9;
    }
  };
  return (
    <section className="job-listing-body-main">
      {openSignUp ? <SignupPortal closeIt={() => setOpenSignUp(false)} /> : ""}
      {openLogin && (
        <LoginPortal
          openSignUp={() => {
            setOpenSignUp(true);
            setOpenLogin(false);
          }}
          closeIt={() => setOpenLogin(false)}
        />
      )}
      {applyModalOpen.status && (
        <ApplyForJob
          closeIt={() => setApplyModalOpen({ status: false, data: null })}
          jobInfo={applyModalOpen.data}
        />
      )}
      <nav>
        <p>
          {otherJobListInfo.total && currentJobList.length ? (
            <>
              Showing{" "}
              <span>
                {(filterConfig.start - 1) * 9 + 1} - {decideLastNumber()}
              </span>{" "}
              <span>Of {otherJobListInfo.total}</span>results
            </>
          ) : (
            ""
          )}
        </p>
      </nav>
      <div className="jlbm-listing">
        {loading ? (
          [1, 2, 3, 4, 5, 6, 7, 8, 9].map((x) => (
            <div className="jbbm-card-wrapper">
              <div className="jbbm-card-loader"></div>
            </div>
          ))
        ) : !currentJobList?.length ? (
          <p style={{ marginBottom: "20px" }}>No Jobs found</p>
        ) : (
          currentJobList?.map((x, num) => (
            <div className="jbbm-card-wrapper">
              <JobOpeningCard
                onStarClick={(obj) => {
                  handleStar(x, num);
                }}
                data={x}
                handleApply={() => handleApply(x)}
              />
            </div>
          ))
        )}
      </div>
      <div className="jlbm-footer">
        <Pagination
          total={otherJobListInfo.total}
          pageSize={9}
          current={parseInt(filterConfig.start)}
          onChange={(obj) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            setFilterConfig({ ...filterConfig, start: obj });
          }}
          className="pagination-section"
          prevIcon={() => (
            <img src="https://img.icons8.com/ios/50/000000/less-than.png" />
          )}
          nextIcon={() => (
            <img src="https://img.icons8.com/ios/50/000000/more-than.png" />
          )}
          jumpPrevIcon = {()=> <img src="https://img.icons8.com/material-outlined/24/000000/more.png"/>}
          jumpNextIcon = {()=> <img src="https://img.icons8.com/material-outlined/24/000000/more.png"/>}
        />
      </div>
    </section>
  );
}
